module.exports = __webpack_public_path__ + "static/media/map-marker.a9b2d581.png";